<script lang="ts" setup>
const config = useRuntimeConfig()
const route = useRoute()
const url = config.public.hostname + route.fullPath
</script>
<template>
	<div class="max-w-screen-xl my-20 px-6 md:px-10 mx-auto">
		<div class="bg-primary-500 rounded-2xl w-full py-10 px-10 text-white">
			<div class="flex flex-col md:flex-row items-center gap-y-4">
				<p class="text-2xl font-light md:mr-auto" v-html="$t('blog.share')"></p>
			
				<div class="flex flex-row items-center gap-6">
					<a aria-label="Share on Facebook" rel="noopener" :href="'http://www.facebook.com/sharer.php?u='+url"  class="rounded-full h-16 w-16 p-2 flex flex-row items-center group hover:bg-white/10 cursor-pointer transition-colors duration-200">
					<IconFacebook class="h-full w-full text-white group-hover:scale-95 transition-transform duration-200" />
					</a>
				
					<a aria-label="Share on Linkedin" rel="noopener" :href="'https://www.linkedin.com/shareArticle?url='+url" class="rounded-full h-16 w-16 p-2 flex flex-row items-center group hover:bg-white/10 cursor-pointer transition-colors duration-200">
						<IconLinkedin class="h-full w-full text-white group-hover:scale-95 transition-transform duration-200" />
					</a>

					<a aria-label="Share on Twitter" rel="noopener" :href="'https://twitter.com/intent/tweet?text='+url" class="rounded-full h-16 w-16 p-3 flex flex-row items-center group hover:bg-white/10 cursor-pointer transition-colors duration-200">
						<IconTwitter class="h-full w-full text-white group-hover:scale-95 transition-transform duration-200" />
					</a>
				</div>
				

			</div>
		</div>
	</div>
	
</template>